export default "<ct-table [tableGridData]=\"tableData\" (editAction)=\"edit($event)\" #gridTable></ct-table>"